import React, { useState, useEffect } from "react";
import "./UserProfile.css";
import Navigation from "../../../Components/Navigation";
export default function UserProfile({ user, onSave }) {
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    name: user?.name || "",
    email: user?.email || "",
    bio: user?.bio || "",
    gender: user?.gender || "",
    dob: user?.dob || "",
    country: user?.country || "",
    interests: user?.interests || "",
    profile_pic: user?.profile_pic || "",
  });
  useEffect(() => {
    if (!editMode) {
      setForm({
        name: user?.name || "",
        email: user?.email || "",
        bio: user?.bio || "",
        gender: user?.gender || "",
        dob: user?.dob || "",
        country: user?.country || "",
        interests: user?.interests || "",
        profile_pic: user?.profile_pic || "",
      });
    }
  }, [user, editMode]);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setForm({ ...form, profile_pic: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSave = () => {
    // Always send dob if present, to ensure age is recalculated
    const updatedForm = { ...form };
    if (form.dob) {
      updatedForm.dob = form.dob;
    }
    onSave(updatedForm);
    setEditMode(false);
  };
  return (
    <div>
      <Navigation user={form} />
      <div className="user-profile-page">
        <div className="user-profile-header">
          <div className="user-profile-avatar-wrap">
            <img
              src={form.profile_pic || "https://ui-avatars.com/api/?name=" + encodeURIComponent(form.name || "User")}
              alt="Profile"
              className="user-profile-avatar"
            />
            {editMode && (
              <div className="user-profile-avatar-input-wrap">
                <label htmlFor="user-profile-avatar-input" className="user-profile-avatar-edit-chip">
                  Edit Photo
                </label>
                <input
                  id="user-profile-avatar-input"
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  className="user-profile-file-input"
                />
              </div>
            )}
          </div>

          <div className="user-profile-meta">
            <h1>{form.name || "Unnamed User"}</h1>
            <p className="user-profile-email">
              {form.email || "No email provided"}
            </p>
          </div>

          {!editMode && (
            <button
              className="user-profile-btn user-profile-btn-edit"
              onClick={() => setEditMode(true)}
            >
              Edit Profile
            </button>
          )}
        </div>
        <div className="user-profile-content">
          {editMode ? (
            <div className="user-profile-form-fields">
              <div className="user-profile-form-grid">
                <div className="user-profile-field">
                  <label className="user-profile-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    className="user-profile-input"
                  />
                </div>

                <div className="user-profile-field">
                  <label className="user-profile-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="user-profile-input"
                  />
                </div>

                <div className="user-profile-field">
                  <label className="user-profile-label">Date of Birth</label>
                  <input
                    type="date"
                    name="dob"
                    value={form.dob ? form.dob.slice(0, 10) : ""}
                    onChange={handleChange}
                    className="user-profile-input"
                  />
                </div>

                <div className="user-profile-field">
                  <label className="user-profile-label">Country</label>
                  <input
                    type="text"
                    name="country"
                    value={form.country}
                    onChange={handleChange}
                    placeholder="Enter your country"
                    className="user-profile-input"
                  />
                </div>

                <div className="user-profile-field">
                  <label className="user-profile-label">Gender</label>
                  <select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    className="user-profile-input"
                  >
                    <option value="">Select gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="user-profile-field user-profile-field-wide">
                  <label className="user-profile-label">Bio</label>
                  <textarea
                    name="bio"
                    value={form.bio}
                    onChange={handleChange}
                    placeholder="Tell us about yourself"
                    className="user-profile-textarea"
                  />
                </div>

                <div className="user-profile-field user-profile-field-wide">
                  <label className="user-profile-label">Interests</label>
                  <textarea
                    name="interests"
                    value={form.interests}
                    onChange={handleChange}
                    placeholder="Your interests, separated by commas"
                    className="user-profile-textarea"
                  />
                </div>
              </div>

              <div className="user-profile-actions">
                <button className="user-profile-btn" onClick={handleSave}>
                  Save
                </button>
                <button
                  className="user-profile-btn user-profile-btn-cancel"
                  onClick={() => setEditMode(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className="user-profile-grid">
              <div className="user-profile-info-card user-profile-about-card">
                <h2>About Me</h2>
                <p>
                  {user?.bio || (
                    <span className="user-profile-placeholder">No bio yet</span>
                  )}
                </p>
              </div>
              <div className="user-profile-info-card">
                <h2>Date of Birth</h2>
                <p>
                  {user?.dob
                    ? user.dob.slice(0, 10)
                    : <span className="user-profile-placeholder">Not specified</span>
                  }
                </p>
              </div>
              <div className="user-profile-info-card">
                <h2>Age</h2>
                <p>
                  {typeof user?.age === 'number' && !isNaN(user.age)
                    ? user.age
                    : <span className="user-profile-placeholder">Not specified</span>
                  }
                </p>
              </div>
              <div className="user-profile-info-card">
                <h2>Country</h2>
                <p>
                  {user?.country || (
                    <span className="user-profile-placeholder">Not specified</span>
                  )}
                </p>
              </div>
              <div className="user-profile-info-card">
                <h2>Gender</h2>
                <p>
                  {user?.gender || (
                    <span className="user-profile-placeholder">Not specified</span>
                  )}
                </p>
              </div>
              <div className="user-profile-info-card">
                <h2>Interests</h2>
                <p>
                  {user?.interests || (
                    <span className="user-profile-placeholder">No interests listed</span>
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
